import type {ComponentType} from 'react'
import {assign, setup, type ActorRefFrom} from 'xstate'

import type {OverlayProps} from './types'

type OverlayComponent = ComponentType<OverlayProps>
interface OverlayManagerContext {
  component?: OverlayComponent
}
type OverlayManagerEvent =
  {type: 'CLOSE'} | {type: 'OPEN'; component: OverlayComponent}

const machine = setup({
  types: {
    context: {} as OverlayManagerContext,
    events: {} as OverlayManagerEvent,
  },
  actions: {
    resetContext: assign({component: undefined}),
    setComponent: assign(({event}) => ({
      component: event.type === 'OPEN' ? event.component : undefined,
    })),
  },
}).createMachine({
  id: 'overlays',
  initial: 'closed',
  context: {component: undefined},
  states: {
    closed: {on: {OPEN: {actions: 'setComponent', target: 'opened'}}},
    closing: {after: {201: {actions: 'resetContext', target: 'closed'}}},
    opened: {on: {CLOSE: 'closing'}},
  },
})

export type OverlayManagerMachine = typeof machine
export type OverlayManagerInterpreter = ActorRefFrom<OverlayManagerMachine>
export default machine
